<template>
    <div>
        <b-card>
            <div class="img-container mt-1">
                <img class="image" src="img/svg/thank-you.svg" />
            </div>
            <h2 align="center" class="mt-3">Awesome</h2>
            <p class="font-weight-bold text-center">
                You have successfully Created User.
            </p>
            <div class="button-wrapper my-2">
                <b-button btn-color="primary" @click="(e) => $emit('done')"
                    >Done</b-button
                >
            </div>
        </b-card>
    </div>
</template>
<script>
export default {
    name: "ThankYou",
};
</script>
<style scoped>
.img-container {
    display: flex;
    justify-content: center;
}
.image {
    height: 300px;
}
</style>
